import PropTypes from 'prop-types';
import styles from './FJNavBar.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJToolTip from '../FJToolTip/FJToolTip.jsx';
import React from 'react';
import FJTextWithEllipsis from '../FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import { useLayoutEffect, useState } from 'react';

const FJNavBar = props => {
    const { selectTab, onChangeTab, tabList, style, isMusicNav } = props;
    const [hasTooltip, setHasTooltip] = useState(false);
    useLayoutEffect(() => {
        _checkHasTooltip();

        window.addEventListener('resize', _checkHasTooltip);
        return () => {
            window.removeEventListener('resize', _checkHasTooltip);
        };
    }, []);

    const _checkHasTooltip = () => {
        setHasTooltip(document.body.clientWidth <= 1400);
    };
    return (
        <ul className={classNames(styles.container, isMusicNav && styles.music_nav)} style={style}>
            {tabList.map(tab => (
                <React.Fragment key={tab.value}>
                    {hasTooltip ? (
                        <FJToolTip title={tab.name} classes={{ tooltip: styles.tooltip, arrow: styles.arrow }}>
                            <li
                                className={classNames(styles.item, {
                                    [styles.active]: selectTab === tab.value,
                                })}
                                onClick={() => onChangeTab(tab.value)}
                            >
                                <tab.icon className={styles.icon} />
                            </li>
                        </FJToolTip>
                    ) : (
                        <li
                            className={classNames(styles.item, {
                                [styles.active]: selectTab === tab.value,
                            })}
                            onClick={() => onChangeTab(tab.value)}
                        >
                            <tab.icon className={styles.icon} />
                            <FJTextWithEllipsis className={styles.name} text={FJLocalStore._(tab.name)} />
                        </li>
                    )}
                </React.Fragment>
            ))}
        </ul>
    );
};

FJNavBar.propTypes = {
    selectTab: PropTypes.string,
    onChangeTab: PropTypes.func,
    tabList: PropTypes.array,
    style: PropTypes.object,
    isMusicNav: PropTypes.bool,
    hasTooltip: PropTypes.bool,
};

export default FJNavBar;
